<template>
  <div class="upload-group">
    <div class="upload-content dashed-array"
    :class="[profileSize, {'border border-dashed border-default': isLabelShow}]">
      <!-- uploaded pic shown here -->
      <img
        class="object-cover cursor-pointer"
        :class="[profilePreviewSize]"
        :src="avatar"
        @click="$refs.fileInput.click()"
        @error="OnImageError"
      />
      <label
        class="upload-label cursor-pointer"
        :class="uploadProgress"
        :style="uploadingProgress"
        v-if="isLabelShow"
        @click="$refs.fileInput.click()"
      >
        <div class="text-center bg-transparent">
          <div class="text-center mb-5">
            <add-photo class="m-auto" width="24" height="24" />
          </div>
          <div class="text-uppercase text-title">
            <slot name="text" />
          </div>
        </div>
      </label>
    </div>
    <input class="hidden" ref="fileInput" type="file" accept="image/*" @change="onInput" />
  </div>
</template>

<script>
import AddPhoto from '@/assets/icons/vue/add_gallery.vue';
import { OnImageError } from '@/utils/on-image-error';

export default {
  name: 'UploadProfilePreview',
  components: { AddPhoto },
  data() {
    return {
      OnImageError,
      selectedFile: '',
    };
  },
  props: {
    size: {
      type: String,
      default: '150',
    },
    uploadedAvatar: {
      type: String,
      default: '',
    },
    isLabelShow: {
      type: Boolean,
      default: true,
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    uploadPercent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    profileSize() {
      return `w-${this.size} h-${this.size}`;
    },
    iconSize() {
      return `w-${this.size / 3} h-${this.size / 3}`;
    },
    profilePreviewSize() {
      return `min-w-${this.size} min-h-${this.size} max-w-${this.size} max-h-${this.size}`;
    },
    uploadProgress() {
      return !this.selectedFile ? 'bg-secondary' : 'bg-secondary opacity-80';
    },
    uploadingProgress() {
      return this.isUploading
        ? `background-image: linear-gradient(0deg, #0071FF ${this.uploadPercent}%, #ffffffcc 0%;`
        : '';
    },
    avatar() {
      if (this.uploadedAvatar) {
        return this.uploadedAvatar;
      }
      if (this.selectedFile) {
        return this.selectedFile;
      }
      return '';
    },
  },
  methods: {
    onInput() {
      const input = this.$refs.fileInput;
      const file = input.files;
      if (file && file[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        const avatarSize = Math.round(file[0].size / 1024);
        if (avatarSize > 10240) {
          this.$toast.error(this.$t('image_size_error'));
          this.$refs.fileInput.value = '';
        } else {
          reader.onload = (e) => {
            this.selectedFile = e.target.result;
          };
          this.$emit('fileUrl', file[0]);
        }
      }
    },
  },
};
</script>
<style lang="css" scoped>
.upload-label {
  @apply absolute flex w-full h-full
          text-subtitle text-12 items-center justify-center;
}
.upload-content {
  @apply relative flex text-center rounded-fullyRound overflow-hidden justify-center
        items-center;
}
.upload-icon {
  @apply absolute text-subtitle top-2/3 right-2/3;
}
.upload-group {
  @apply relative text-center flex justify-center;
}
</style>
